import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import {
  AppComponent,
  AppComponentModule,
  DataService,
  LoggingDataService
} from '@vendure/admin-ui/core'
import { AngularFireModule } from '@angular/fire/compat'
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging'
import { AngularFireAnalyticsModule } from '@angular/fire/compat/analytics'
import { routes } from './app.routes'
import { environment } from 'src/environments/environment'

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AppComponentModule,
    RouterModule.forRoot(routes, {
      useHash: false,
      scrollPositionRestoration: 'top'
    }),
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireMessagingModule,
    AngularFireAnalyticsModule
  ],
  providers: [
    {
      provide: DataService,
      useClass: LoggingDataService
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
